const refundActions = {
    GET_REFUND_LIST: 'GET_REFUND_LIST',
    SET_REFUND_LIST: 'SET_REFUND_LIST',

    EXPORT_REFUND_LIST: 'EXPORT_REFUND_LIST',

    MARK_REFUNDED: 'MARK_REFUNDED',
    SET_MARK_REFUND_ERRORS: 'SET_MARK_REFUND_ERRORS',

    PREVIEW_BULK_REFUND: 'PREVIEW_BULK_REFUND',
    SET_BULK_REFUND_PREVIEW: 'SET_BULK_REFUND_PREVIEW',
    CONFIRM_BULK_REFUND: 'CONFIRM_BULK_REFUND',
    CLEAR_BULK_REFUND_PREVIEW: 'CLEAR_BULK_REFUND_PREVIEW'
};

export default refundActions;
